import { UserRoles } from 'src/common/enums';
import { useGetUserQuery } from 'src/common/slices';

export const useIsRoomMaker = () => {
  const { data: userData } = useGetUserQuery();
  return userData?.data?.user?.roles?.includes(UserRoles.ROOM_MAKER) ?? false;
};
